import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4knjkc8j: FaireBrandEntity = {
  token: "b_4knjkc8j",
  type: "brand",
  name: "Primitives by Kathy",
  avatarUrl: "https://cdn.faire.com/fastly/96113c5a90c090ec92ec417bcd0f128fa4481fdba18c6756af5d2f8c847a3a7f.png",
  bannerUrl: "https://cdn.faire.com/fastly/8d8ca5bca9a4d79d0bea700be44f81040f3fbc8524cc230f7f2be2ae1da2eaa2.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/96113c5a90c090ec92ec417bcd0f128fa4481fdba18c6756af5d2f8c847a3a7f.png",
  heroImageUrl: "https://cdn.faire.com/fastly/8d8ca5bca9a4d79d0bea700be44f81040f3fbc8524cc230f7f2be2ae1da2eaa2.jpeg",
  location: "Lancaster, PA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 1807,
  isTopShop: true,
  isInsider: true,
  description: "Primitives by Kathy began in 1997 when Kathy handmade her first “primitive candle box” — carefully sanding the edges, tying ribbons by hand, and crafting each piece with heart. What started as a creative passion quickly became a growing business, fueled by her entrepreneurial spirit and a love of meaningful design.\n\nAs demand grew, Kathy partnered with Goodwill Services to help produce her handmade creations — forming a philanthropic partnership that continues to this day and remains core to PBK’s mission.\n\nMore than 25 years later, Primitives by Kathy has grown from one candle box to over 8,000 items, offering heartfelt gifts and home décor that blend creativity, humor, and inspiration. Recognized as a leader and trendsetter in the gift industry, PBK continues to create products that bring connection, laughter, and joy to homes everywhere.\n\nKathy remains at the helm, guiding the brand with her artistic vision, innovative spirit, and dedication to giving back.",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:45.738Z",
    importedBy: "entity-db-cli"
  }
};
